import React, { useState, useEffect, useRef, useCallback } from 'react';
import Logo from "../images/logo.svg";
import Sidebar from '../component/Sidebar';
import { Tabs, SelectPicker, TagPicker, Placeholder } from "rsuite";
// import { SelectPicker, DatePicker, Dropdown, Placeholder, Tabs, Whisper, Popover, Button, Tooltip, Message } from 'rsuite';
import "rsuite/SelectPicker/styles/index.css";
import debounce from 'lodash.debounce';
import { ChakraProvider, useToast, Wrap } from '@chakra-ui/react'
import { FaLessThanEqual } from 'react-icons/fa';

const TagData = ['Electronic Technology', 'Technology', 'Banking Services', 'Basic Materials', 'Basic Materials/Resources', 'Business/Consumer Services', 'Chemicals', 'Communication Services', 'Construction Materials'].map(
    item => ({
        label: item,
        value: item,
        role: Math.random() > 0.5 ? 'Owner' : 'Guest'
    })
);


function IRILibrary() {

    const [tabName, setTabName] = useState('Library');

    useEffect(() => {
        document.title = tabName;
    }, [tabName]);
    const abortControllerRef = useRef(null);
    const [isLoading, setLoading] = useState(true); // State to manage loading state
    const [industries, setIndustries] = useState([]);
    const [weightageData, setWeightageData] = useState({});

        const [customPaginationValue, setCustomPaginationValue] = useState("");
        const [reportCount, setReportCount] = useState(0);
        const [currentPage, setCurrentPage] = useState(1);
        const [pageRange, setPageRange] = useState("10");
        const [searchInput, setSearchInput] = useState("");
        const [flag1, setFlag1] = useState(0);
        const userid = localStorage.getItem("novauserid");
        const apiEndPoint = process.env.REACT_APP_API_ESG_ENDPOINT;
        const [industryData, setIndustryData] = useState([]);
        const [industryId, setIndustryId] = useState("");

          const toast = useToast()
          const toastIdRef = React.useRef()

useEffect(() => {
  if (!industries || industries.length === 0) return;

  setIndustries(industries);

  const initialWeightage = {};
  industries.forEach(ind => {
    initialWeightage[ind.id] = {};
    ind.categories.forEach(category => {
      initialWeightage[ind.id][category.category_id] = category.weitage.toString();
    });
  });

  setWeightageData(initialWeightage);
}, [industries]);


const handleWeightageChange = (industryId, dimId, value) => {
        setWeightageData(prev => ({
            ...prev,
            [industryId]: {
                ...prev[industryId],
                [dimId]: value
            }
        }));
};

    
const getTotalWeightage = (industryId) => {
  const weightages = weightageData[industryId];
  if (!weightages) return 0;

  return Object.values(weightages).reduce((sum, val) => sum + Number(val || 0), 0);
};

const handleSave = async (industryId) => {
    if (toastIdRef.current && toast.isActive(toastIdRef.current)) { toast.close(toastIdRef.current); }

            const updatedDims = Object.entries(weightageData[industryId] || {}).map(([dimId, weightage]) => ({
                category_id: parseInt(dimId),
                weightage: Number(weightage)
            }));


            const payload = {
                data: {
                    user_id: userid, // replace with dynamic user_id if needed
                    industry_id: industryId,
                    categories: updatedDims
                }
            };
        

            try {
                const response = await fetch(`${apiEndPoint}/update_misri_library `, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });
        
                const result = await response.json();
        
                if (result?.data?.status === "success") {
                    setFlag1(prev => prev + 1);
                    toastIdRef.current = toast({ description: result.data.message, status: 'success', duration: 5000, isClosable: true, position: 'bottom', });
                    // Optionally show success message in UI
                } else {
                    toastIdRef.current = toast({ description: result.data.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
                    console.error("❌ Failed to update weightages:", result);
                    // Optionally show error message in UI
                }
            } catch (error) {
                toastIdRef.current = toast({ description: error.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
                console.error("❌ API Error:", error);
                // Optionally show network error in UI
            }
};

    const fetchEsgLibraryData = async () => {
        setLoading(true);
    
        // Cancel the previous request if any
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
    
        const controller = new AbortController();
        abortControllerRef.current = controller;
    
        try {
            const apiUrl = `${apiEndPoint}/misri_library`;
            const requestData = {
                data: {
                    page: currentPage.toString(),
                    limit: pageRange,
                    order: 'ASC',
                    q: searchInput,
                    user_id:userid,
                    industry:industryId,
                }
            };
    
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestData),
                signal: controller.signal
            });
    
            const jsonData = await response.json();
            const { data } = jsonData; // destructuring

            if (data.status === 'success') {
                setLoading(false);
                console.log('ESG Library Data:', data.data);
                setIndustries(data.data); // assuming you're using useState
                setReportCount(data.count);
            } else {
                setLoading(false);
                toastIdRef.current = toast({ description: data.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
                console.error("Error:", data.message);
            }
    
        } catch (error) {
            if (error.name === "AbortError") {
                setLoading(false);
                console.log("Request cancelled");
            } else {
                setLoading(false);
                console.error("Fetch error:", error.message);
                toastIdRef.current = toast({ description: error.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
            }
        } finally {
            
        }
    };


     useEffect(() => {
        fetchEsgLibraryData();
      }, []);

    useEffect(() => {
        fetchEsgLibraryData();
    }, [currentPage, pageRange,flag1, industryId]); // Regular effect for other dependencies
         
    
       useEffect(() => {
            const fetchIndustryList = async () => {
              const url = `${apiEndPoint}/misri_industry`;
              const payload = {
                data: {
                  user_id: userid // Replace with the actual user_id if dynamic
                }
              };
          
              try {
                const response = await fetch(url, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(payload),
                });
          
                if (!response.ok) {
                  throw new Error('Network response was not ok');
                }
          
                const responseData = await response.json();
                const data = responseData.data; // Flatten the response
        
                const formattedIndustryData = data.data.map((industry) => ({
                  label: industry.industry,
                  value: industry.id,
                }));
        
                setIndustryData(formattedIndustryData);
          
              } catch (error) {
                console.log('error :'+ error.message);
                return false;
              }
            };
          
            fetchIndustryList();
          }, []);

    






    // EQUAL HEIGHT DIV
    const cellRefs = useRef([]);

   useEffect(() => {
    const rows = document.querySelectorAll('.esg_library_table tbody tr');
    rows.forEach(row => {
      let maxHeight = 0;
      const cells = row.querySelectorAll('.equal-cell');
      cells.forEach(cell => {
        cell.style.height = 'auto'; // reset before measuring
        maxHeight = Math.max(maxHeight, cell.offsetHeight);
      });
      cells.forEach(cell => {
        cell.style.height = maxHeight + 'px';
      });
    });
  }, [industries]);

      const handlePaginationChange = (e) => {
          const value = (e.target.value == 0 ? 1 : e.target.value).toString() ;
          setCustomPaginationValue(value); // Update input value immediately for fast typing
          debouncedSetPage(Number(value)); // Trigger the debounced function
        };
      
        const handlePagelimit = (value) => {
          setCurrentPage(1);
          setCustomPaginationValue(1);
          setPageRange(value); 
        };
      
        
        const debouncedSetPage = useCallback(
              debounce((page) => {
                setCurrentPage(page);
              }, 500), // Delay of 500ms (half a second)
              []
        );
            
        const debouncedFetchGlobalReport = useCallback(
                  debounce(() => {
                    fetchEsgLibraryData();
                  }, 500),
                  [searchInput] // Only debounce on search input changes
        );
              
        useEffect(() => {
                  debouncedFetchGlobalReport();
                  return () => {
                    debouncedFetchGlobalReport.cancel();
                  };
        }, [searchInput]);
            
      const handleIndustryChange = (value) => {
        setCurrentPage(1);
        setIndustryId(value);
      };
	  

  // PAGINATION
  const PagingData = ['10', '20', '50', '100'].map(
    item => ({ label: item, value: item })
  );

        const renderPagination = () => {
          // Calculate total number of pages
          const totalPages = Math.ceil(reportCount / pageRange);
        
          // Show a default of 3 pages if the total pages are more than 3
          const pageNumbers = [];
          const visiblePageCount = 4; // Number of pages to show by default
        
          let startPage = currentPage - 1;
          let endPage = currentPage + 2;
        
          // Adjust pagination if total pages are less than the default
          if (totalPages <= visiblePageCount) {
            startPage = 1;
            endPage = totalPages;
            
          } else {
            
            // Ensure the pagination does not go out of bounds
            startPage = Math.max(1, startPage);
            endPage = Math.min(totalPages, endPage);
          }
        
          // Create page numbers to display based on current page
          for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
          }
        
          return (
            <nav aria-label="..." id='pagination_row' style={{alignItems:'center', justifyContent:'space-between', background:'#FFF', paddingTop:0, paddingBottom:0}}>
              <div className='totalRecords'>
                Total Records :  {Number(reportCount).toLocaleString()}
              </div>
              <ul className="pagination" style={{border: 0, background: 'none'}}>
      
              <li class="page-item" style={{marginLeft:10}}>
                            <SelectPicker onChange={handlePagelimit} cleanable={false}
                            value={pageRange} 
                            placement="top" placeholder='Pages' data={PagingData} searchable={false} style={{ width: 85, height:35, display:'flex', alignItems:'center', borderRadius: 5, border: '1px solid #A1B9ED'}} />
                          </li>
      
                {/* Previous Page (Double Arrow) */}
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`} style={{marginLeft: 10}}>
                  <a href="#" className="page-link" onClick={() =>  setCurrentPage(1)}>
                    <i className="fa fa-angle-double-left"></i>
                  </a>
                </li>
        
                {/* Previous Page (Single Arrow) */}
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <a href="#" className="page-link" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}>
                    <i className="fa fa-angle-left"></i>
                  </a>
                </li>
        
                {/* Page numbers */}
                {pageNumbers.map(page => (
                  <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                    <a 
                      className="page-link" href="#" 
                      onClick={() => setCurrentPage(page)} // Set the clicked page as the current page
                    >
                      {page}
                    </a>
                  </li>
                ))}
                
                {/* Next Page (Single Arrow) */}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <a href="#" className="page-link" onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}>
                    <i className="fa fa-angle-right"></i>
                  </a>
                </li>
        
                {/* Next Page (Double Arrow) */}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`} style={{marginRight: 10}}>
                  <a href="#" className="page-link" onClick={() => setCurrentPage(totalPages)}>
                    <i className="fa fa-angle-double-right"></i>
                  </a>
                </li>
                
                {/* Go to Page */}
                <li className="page-item" style={{marginLeft: 10, display: 'flex', alignItems: 'center', gap: 5}}>
                  <input
                    type="text"
                    placeholder="Go#"
                    className="form-control"
                    value={customPaginationValue}
                    onChange={handlePaginationChange}
                    onInput={(e) => {
                      // Only allow numbers
                      e.target.value = e.target.value.replace(/[^0-9]/g, '');
                    }}
                  
                    style={{
                      padding: '0px 10px', 
                      color: '#878787', 
                      fontSize: 16, 
                      borderRadius: 5, 
                      border: '1px solid #A1B9ED', 
                      width: 60, 
                      height: 35, 
                      textAlign: 'center'
                    }}
                  />
                </li>
              </ul>
            </nav>
          );
        };


        const handleSearch = (event) => {
            console.log(event.target.value);
            setSearchInput(event.target.value);
            setCurrentPage(1); // Reset to the first page for new search
          };


          const handleClearFilters = () => {
            setCurrentPage(1);
            setIndustryId("");
            setSearchInput("");
          };

    return (
        <>
            <Sidebar />
            <ChakraProvider></ChakraProvider>
            <div id='header'>
                <div className='logo'>
                    <div className='logo_icon'>
                        <img src={Logo} />
                    </div>
                    <div className='brand_name'>ISRI Library</div>
                </div>

                <div className='header_table_filter' style={{ width: "auto" }}>
                    <div className='searchfield' style={{ maxWidth: 220 }}>
                        <button className='btn_search'><i className='icon-search'></i></button>
                        <input type='text' className='filter_searchfield' placeholder='Search by Industry'   onChange={handleSearch}
                value={searchInput} />
                    </div>

                    <div className='dropdown_style filter_by_country'>
                        <SelectPicker
                            data={industryData}
                            searchable={false}
                            style={{ width: 230 }}
                            placeholder="Select Industry"
                            onChange={handleIndustryChange}
                            value={industryId}
                        />
                    </div>
                    <a href='javascript:void(0)' className="btn_clear_filter"  style={{textDecoration:"none"}} onClick={handleClearFilters}>Clear Filters</a>
                </div>
            </div>
            <div className="container-fluid content pb-5">


                    <>
                        <div className='sector_title_desc_row'>
                            <div>
                                <h5>Industry- Specific Material Issues Weightage</h5>
                                <p>This section highlights how different material issues are prioritized across various industries based on their relevance and impact.</p>
                            </div>
                            {/* {!isLoading && (
                            <a href='#' className='btn_create_sector_group'>Save All</a>
                        )} */}

                        </div>
                        {isLoading && (
                <Placeholder.Grid
                  rows={20}
                  columns={11}
                  active
                  style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }}
                />
              )}
                        {!isLoading && (

                        <div className='tab_content_main' style={{ padding: 20, borderRadius: 16, backgroundColor: '#FFF', boxShadow: '0px 2px 24px 1px rgba(225, 225, 225, 0.80), 0px 2px 24px 1px rgba(225, 225, 225, 0.80)' }}>
                            <div className='sector_industry_table'>
                                <div className='table-responsive' style={{ paddingBottom: 40 }}>
                                    <table className='table esg_library_table'>
                                        <thead>
                                            <tr>
                                                <th>Name of the Industry</th>
                                                <th><div className="esg_library_th">Material Issues</div></th>
                                                <th style={{ textAlign: 'right' }}>Weightage</th>
                                                <th style={{ textAlign: 'center' }}>Check point</th>
                                                <th style={{ textAlign: 'center' }}><div className="esg_library_th">Actions</div></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                       
                                        {industries.map((industry, index) => {
                                              const categories = industry.categories;
                                              const totalWeight = getTotalWeightage(industry.id);
                                              return (
                                            <tr>
                                                <td>
                                                    <div className='sector_category_td_col d-flex align-items-center equal-cell' ref={(el) => cellRefs.current[0] = el}>
                                                     {industry.industry_name}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='sector_name_td_col esg_sector_name_td_col equal-cell' ref={(el) => cellRefs.current[1] = el} style={{ borderRight: 0 }}>
                                                   {categories.map(category => (
                                                      <p key={category.category_id}>{category.category_name}</p>
                                                   ))}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='equal-cell' ref={(el) => cellRefs.current[2] = el}>
                                                   {categories.map(category => (
                <div className='esg_weightage_field_cell' key={category.category_id}>
                  <input
                    type="text"
                    className='weightage_field'
                    defaultValue={category.weitage}
                    value={weightageData[industry.id]?.[category.category_id] || ''}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        handleWeightageChange(industry.id, category.category_id, value);
                      }
                    }}
                  />
                  <span>%</span>
                </div>
              ))}

                                                    </div>
                                                </td>
                                                <td style={{ textAlign: 'center' }}>
                                                    <div className={`checkpoints ${getTotalWeightage(industry.id) === 100 ? 'green_total_checkpoint' : 'red_total_checkpoint'} equal-cell`} ref={(el) => cellRefs.current[index] = el}>
                                                        <div className='checkpoints_inner'><i className={getTotalWeightage(industry.id) === 100 ? 'icon-check' : 'icon-cross'}></i><span>Total: {getTotalWeightage(industry.id)}%</span></div>
                                                        {getTotalWeightage(industry.id) !== 100 && (
                                                            <h6>Total Must be 100%</h6>
                                                        )}
                                                    </div>
                                                </td>
                                                <td style={{ textAlign: 'center' }}>
                                                    <div className='sector_action esg_sector_action equal-cell' ref={(el) => cellRefs.current[4] = el}>
                                                        <a href="#!" className={`btn__save ${getTotalWeightage(industry.id) != 100 ? 'btn__disabled' : ''}`}  onClick={() => handleSave(industry.id)}>Save</a>
                                                    </div>
                                                </td>
                                            </tr>
                                            );
})}
                                        </tbody>
                                    </table>
                                    {reportCount > 0 && renderPagination()}
                                </div>

                            </div>
                        </div>
                        )}
                    </>
              
               

            </div>


            <div class="modal fade report_delete_modals" id="ReportDeleteModal" tabindex="-1" aria-labelledby="ReportDeleteModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-body">
                            <h5>Are you sure you want to delete <br />this sector group ?</h5>
                            <p>This action cannot be reversed</p>
                            <div class="btn__group mt-5" style={{}}>
                                <button type="button" class="btn_cancel" data-bs-dismiss="modal">Cancel</button>
                                <button type="button" class="btn_delete">Delete</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="modal fade report_delete_modals" id="IndustryDeleteModal" tabindex="-1" aria-labelledby="IndustryDeleteModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-body">
                            <h5>Are you sure you want to delete <br />this industry group ?</h5>
                            <p>This action cannot be reversed</p>
                            <div class="btn__group mt-5" style={{}}>
                                <button type="button" class="btn_cancel" data-bs-dismiss="modal">Cancel</button>
                                <button type="button" class="btn_delete">Delete</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <div class="modal fade create_sector_modals" id="CreateIndustryGroupModal" tabindex="-1" aria-labelledby="CreateIndustryGroupModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title">Create a New Industry Group</h1>
                            <p>Add industries to merge them into a new industry group. You can add <br />more industries or delete industries later.</p>
                        </div>

                        <div class="modal-body">
                            <div className=''>
                                <label>Industry Group Name</label>
                                <input type='text' className='form-control' placeholder='Enter Industry Name' />
                            </div>

                            <div className='mt-4'>
                                <label>Add Industries</label>
                                <TagPicker
                                    creatable
                                    data={TagData}
                                    className='custom_tagpicker'
                                    style={{ width: '100%', minHeight: 48, borderRadius: 4, border: '1px solid #FDC152', display: 'flex', alignItems: 'center' }}
                                    menuStyle={{}}
                                    menuClassName='custom_dropdown_menu'
                                    placeholder='Add Industries to merge'
                                    onCreate={(value, item) => {
                                        console.log(value, item);
                                    }} />
                            </div>

                            <div class="btn__group mt-5" style={{}}>
                                <button type="button" class="btn_cancel" data-bs-dismiss="modal" style={{ width: 158 }}>Cancel</button>
                                <button type="button" class="btn_delete" style={{ gap: 12, width: 158 }}><i className='icon-plus'></i>Create</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="modal fade create_sector_modals" id="CreateSectorGroupModal" tabindex="-1" aria-labelledby="CreateSectorGroupModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title">Create a New Sector Group</h1>
                            <p>Add sectors to merge them into a new sector group. You can add <br />more sectors or delete sectors later.</p>
                        </div>

                        <div class="modal-body">
                            <div className=''>
                                <label>Sector Group Name</label>
                                <input type='text' className='form-control' placeholder='Enter Sector Name' />
                            </div>

                            <div className='mt-4'>
                                <label>Add Sectors</label>
                                {/* <input type='text' className='form-control' placeholder='Add Sectors to merge' /> */}
                                <TagPicker
                                    creatable
                                    data={TagData}
                                    className='custom_tagpicker'
                                    style={{ width: '100%', minHeight: 48, borderRadius: 4, border: '1px solid #FDC152', display: 'flex', alignItems: 'center' }}
                                    menuStyle={{}}
                                    menuClassName='custom_dropdown_menu'
                                    placeholder='Add Sectors to merge'
                                    onCreate={(value, item) => {
                                        console.log(value, item);
                                    }} />
                            </div>

                            <div class="btn__group mt-5" style={{}}>
                                <button type="button" class="btn_cancel" data-bs-dismiss="modal" style={{ width: 158 }}>Cancel</button>
                                <button type="button" class="btn_delete" style={{ gap: 12, width: 158 }}><i className='icon-plus'></i>Create</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="modal fade create_sector_modals" id="EditSectorGroupModal" tabindex="-1" aria-labelledby="EditSectorGroupModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title">Edit Sector Group</h1>
                            <p>Add or delete sectors from an existing sector group.</p>
                        </div>

                        <div class="modal-body">
                            <div className=''>
                                <label>Sector Group Name</label>
                                <input type='text' className='form-control' placeholder='Enter Sector Name' />
                            </div>

                            <div className='mt-4'>
                                <label>Add Sectors</label>
                                {/* <input type='text' className='form-control' placeholder='Add Sectors to merge' /> */}
                                <TagPicker
                                    creatable
                                    data={TagData}
                                    className='custom_tagpicker'
                                    style={{ width: '100%', minHeight: 48, borderRadius: 4, border: '1px solid #FDC152', display: 'flex', alignItems: 'center' }}
                                    menuStyle={{}}
                                    menuClassName='custom_dropdown_menu'
                                    placeholder='Add Sectors to merge'
                                    onCreate={(value, item) => {
                                        console.log(value, item);
                                    }} />
                            </div>

                            <div class="btn__group mt-5" style={{}}>
                                <button type="button" class="btn_cancel" data-bs-dismiss="modal" style={{ width: 158 }}>Cancel</button>
                                <button type="button" class="btn_delete" style={{ width: 158 }}>Save Changes</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </>
    );
}

export default IRILibrary;
